"use client";
import { usePathname, useRouter } from "@/routing/navigation";
import { CurrThemeProvider } from "./themes/CurrThemeProvider";
import { FullScreenLoading } from "./ui/FullScreenLoading";
import { trpc } from "./utils/trpc";
import { useEffect } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// /design-review handles its own (dev-only) sign-in.
const publicPaths = ["/", "/check-email", "/forgot-password", "/design-review"];
const publicPathsStartWiths = ["/confirm-email/", "/accept-invite/", "/set-password/", "/shared/"];

function Template({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  const router = useRouter();
  const isPublicPath = publicPaths.includes(pathname) || publicPathsStartWiths.some((p) => pathname.startsWith(p));
  const { data, isLoading } = trpc.getMe.useQuery(undefined, {
    enabled: !isPublicPath,
  });

  useEffect(() => {
    if (!isPublicPath && !isLoading && !data?.user && pathname !== "/login" && pathname !== "/register") {
      router.replace("/login");
    }
  }, [data?.user, isLoading, isPublicPath, pathname, router]);

  useEffect(() => {
    if (data?.user && (pathname === "/login" || pathname === "/register")) {
      const firstProject = data.projects.at(0);
      const hasStudioState = new URLSearchParams(window.location.search).has("studio");
      if (firstProject && !hasStudioState) {
        router.replace(`/p/${firstProject.id}`);
      }
    } else if (data?.user && data.projects.length === 0 && pathname.startsWith("/p/")) {
      router.replace(
        `/login?studio=${data.accessState === "entitlement_unavailable" ? "entitlement_unavailable" : "no_access"}`,
      );
    }
  }, [data, pathname, router]);

  if (isLoading) {
    return <FullScreenLoading />;
  }

  return (
    <CurrThemeProvider>
      {children}
      <ToastContainer />
    </CurrThemeProvider>
  );
}

export default Template;
